import { Divider as RNEDivider, useTheme } from "react-native-elements";

export default function Divider(props: any) {
  const theme = useTheme();
  return <RNEDivider color={theme.theme.colors.divider} {...props} />;
}
